'use strict';

/** @type {import('./gOPD')} */
module.exports = Object.getOwnPropertyDescriptor;



//////////////////
// WEBPACK FOOTER
// ./~/get-intrinsic/~/gopd/gOPD.js
// module id = 419
// module chunks = 0